import { createContext } from 'react';
import { FeatureFlagContextType } from './types';

const defaultContext: FeatureFlagContextType = {
  featureFlags: {},
  isLoading: false,
};

export const FeatureFlagContext =
  createContext<FeatureFlagContextType>(defaultContext);
